import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BubbleBackground from './components/BubbleBackground';
import BottomNavigation from './components/BottomNavigation';
import PageLoader from './components/PageLoader';
import ChatBot from './components/ChatBot';
import SEO from './components/SEO';
import './App.css';

// Lazy load all page components
const Home = React.lazy(() => import('./pages/Home'));
const About = React.lazy(() => import('./pages/About'));
const Books = React.lazy(() => import('./pages/Books'));
const Speaking = React.lazy(() => import('./pages/Speaking'));
const Blog = React.lazy(() => import('./pages/Blog'));
const Testimonials = React.lazy(() => import('./pages/Testimonials'));
const Gallery = React.lazy(() => import('./pages/Gallery'));
const Contact = React.lazy(() => import('./pages/Contact'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = React.lazy(() => import('./pages/TermsOfService'));
const CookiePolicy = React.lazy(() => import('./pages/CookiePolicy'));
const RefundPolicy = React.lazy(() => import('./pages/RefundPolicy'));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <SEO />
          <BubbleBackground />
          <Navigation />
          <main>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/books" element={<Books />} />
                  <Route path="/speaking" element={<Speaking />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/testimonials" element={<Testimonials />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <BottomNavigation />
          <ScrollToTop />
          <ChatBot />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
